import { Guid, Lmid } from "@/types"

export interface IGetNotificationAssetDto {
    assetId: Guid
    lmid?: Lmid
    isAssetLabeled?: boolean
    articleDescription?: string
}

export default class NotificationAsset {
    assetId: Guid
    lmid?: Lmid
    isAssetLabeled?: boolean
    linkedToAssetCollection?: boolean
    articleDescription?: string

    constructor(dto: IGetNotificationAssetDto) {
        this.assetId = dto.assetId
        this.lmid = dto.lmid
        this.isAssetLabeled = dto.isAssetLabeled
        this.linkedToAssetCollection = dto.isAssetLabeled
        this.articleDescription = dto.articleDescription
    }
}
